// extracted by mini-css-extract-plugin
export default {"chatBoxContainer":"ChatBox_chatBoxContainer__WZDgu"};